import { Children, FC, ReactNode } from 'react'

interface MasonryProps {
  children?: ReactNode | undefined
}

const Masonry: FC<MasonryProps> = ({ children }) => {
  const childs = Children.toArray(children)
  const half = Math.ceil(childs.length / 2)
  const firstColumn = childs.slice(0, half)
  const secondColumn = childs.slice(half, childs.length)

  return (
    <div className="row">
      <div className="col-12 col-md-6">
        <div className="row">
          {firstColumn.map((child, index) => (
            <div key={`masonry-first-half-${index}`}>{child}</div>
          ))}
        </div>
      </div>
      <div className="col-12 col-md-6">
        <div className="row">
          {secondColumn.map((child, index) => (
            <div key={`masonry-second-half-${index}`}>{child}</div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Masonry
